import { cva } from 'class-variance-authority';

const button = cva([
  'border-2 tracking-wide block outline-2 outline-offset-2 outline-primary focus:outline'
], {
  variants: {
    intent: {
      none: [
        'text-gray-800',
        'border-gray-100',
        'hover:bg-gray-100',
        'outline-slate-400',
      ],
      primary: [
        'font-medium',
        'text-white',
        'bg-primary',
        'border-primary',
        'hover:bg-primary-focus',
        'hover:border-primary-focus',
        'outline-primary-focus',
      ],
      'primary-focus': [
        'font-medium',
        'text-white',
        'bg-primary-focus',
        'border-primary-focus',
        'hover:bg-primary-focus/50',
        'hover:border-white/10',
        'outline-primary-focus/50',
      ],
      secondary: [
        'font-medium',
        'text-white',
        'bg-slate-600',
        'border-slate-600',
        'hover:bg-slate-800',
        'hover:border-slate-800',
        'outline-slate-800',
      ],
      info: [
        'font-medium',
        'text-white',
        'bg-cyan-500',
        'border-cyan-500',
        'hover:bg-cyan-700',
        'hover:border-cyan-700',
        'outline-cyan-700',
      ],
      success: [
        'font-medium',
        'text-white',
        'bg-green-600',
        'border-green-600',
        'hover:bg-green-800',
        'hover:border-green-800',
        'outline-green-800',
      ],
      link: [
        'border-transparent',
        'text-indigo-700',
        'hover:underline',
      ],
      tab: [
        'font-medium',
        'text-gray-800',
        'border-transparent',
        'hover:bg-gray-100',
        'outline-slate-400',
      ],
      menuItem: [
        'flex',
        'border-transparent',
        'hover:bg-gray-100',
      ],
    },
    size: {
      xs: ['text-xs', 'px-1.5', 'py-1', 'rounded-md'],
      sm: ['text-sm', 'px-2', 'py-1', 'rounded-md'],
      md: ['text-base', 'px-3', 'py-2', 'rounded-lg'],
      lg: ['text-lg', 'px-5', 'py-3', 'rounded-xl']
    },
    active: {
      true: '',
    },
    block: {
      true: 'w-full',
    },
    disabled: {
      true: 'opacity-50 pointer-events-none'
    },
    align: {
      left: 'text-left',
      center: 'text-center',
    },
  },
  compoundVariants: [{
    intent: 'none',
    active: true,
    class: 'border-gray-200'
  }, {
    intent: 'tab',
    active: true,
    class: 'bg-gray-100'
  }],
  defaultVariants: {
    intent: 'none',
    size: 'md',
    align: 'center',
  },
});

export default button;
